/**
 * Fetch interceptor to add JWT token to requests and handle 401 responses
 * This wraps the native fetch function to add authentication headers
 */

// Store the original fetch function
const originalFetch = window.fetch;

// Create a wrapper that adds JWT token to all requests
window.fetch = async (...args) => {
  let [resource, config] = args;

  // Get JWT token from localStorage
  const token = localStorage.getItem('jwt_token');

  // Add Authorization header if token exists
  if (token) {
    config = config || {};
    config.headers = config.headers || {};

    // Only add Authorization header if not already present
    if (!config.headers.Authorization && !config.headers.authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }

  // Make the request with modified config
  try {
    const response = await originalFetch(resource, config);

    // Handle 401 Unauthorized responses
    if (response.status === 401) {
      // Check if this is not the login endpoint to avoid infinite loops
      const url = typeof resource === 'string' ? resource : resource.url;
      const isLoginEndpoint = url.includes('/api/auth/login');

      if (!isLoginEndpoint) {
        // Token is invalid/expired - clear auth and redirect to login
        localStorage.removeItem('jwt_token');
        localStorage.removeItem('username');

        // Redirect to login page
        if (!window.location.pathname.includes('/ui/login')) {
          window.location.href = '/ui/login';
        }
      }
    }

    return response;
  } catch (error) {
    // Re-throw the error so calling code can handle it
    throw error;
  }
};

// Export for use in main app initialization
export const initializeFetchInterceptor = () => {
  // This function is called to ensure the interceptor is set up
  // The actual interception happens when this module is imported
  console.log('Fetch interceptor initialized');
};
